import React, {FC} from 'react';
import styled, {css} from 'styled-components';

import {Trans} from '../../../../../../libs/shared/helpers/src/internationalization/react';
import {fontWeights} from '../../../../../../libs/shared/ui/src/styles/fontStyles';

/*
 * Props.
 */

export enum GoOnlineBannerRenderLocationsEnum {
  P2,
  P3,
}

export interface GoOnlineBannerProps {
  renderLocation: GoOnlineBannerRenderLocationsEnum;
}

/*
 * Style.
 */

const StyledContainerDiv = styled.div`
  display: flex;
`;

interface PillStyleProps {
  $renderLocation: GoOnlineBannerRenderLocationsEnum;
}
const StyledPillDiv = styled.div<PillStyleProps>`
  border-radius: 100px;
  margin: 24px auto;

  ${(p) => makeStyleForRenderLocation(p.$renderLocation)}
`;

const StyledTextDiv = styled.div`
  color: ${(p) => p.theme.greys.shade70};
  font-size: 12px;
  line-height: 14px;
  font-weight: ${fontWeights.semibold};
`;

function makeStyleForRenderLocation(renderLocation: GoOnlineBannerRenderLocationsEnum) {
  if (renderLocation === GoOnlineBannerRenderLocationsEnum.P2) {
    return css`
      background-color: ${(p) => p.theme.greys.shade20};
      padding: 6px 8px 5px 8px;
    `;
  }

  return css`
    background-color: ${(p) => p.theme.greys.shade30};
    padding: 10px 14px 9px 14px;
  `;
}

/*
 * Component.
 */

export const GoOnlineBanner: FC<GoOnlineBannerProps> = (props) => (
  <StyledContainerDiv>
    <StyledPillDiv $renderLocation={props.renderLocation}>
      <StyledTextDiv>
        <Trans id="activity-goonline-title">That&apos;s it! Go online to load more</Trans>
      </StyledTextDiv>
    </StyledPillDiv>
  </StyledContainerDiv>
);
